
export default {
  inject: ['product', 'wording'],
  data() {
    return {
      product: this.product,
      wording: this.wording,
    }
  },
  computed: {
    fittingGuideIndicator() {
      switch (this.product?.fitting_guide) {
        case 'runs_small_size_up':
          return 'left'
        case 'between_small_true':
          return 'middle-left'
        case 'true_to_size':
          return 'center'
        case 'between_large_true':
          return 'middle-right'
        case 'runs_large_size_down':
          return 'right'
        default:
          return null
      }
    },
    haveDimensions() {
      return (
        Object.values(this.product?.sizes_details?.dimensions)?.filter(
          (value) => value
        )?.length > 0
      )
    },
    dimensionEntries() {
      return (
        Object.entries(this.product?.sizes_details?.dimensions)?.filter(
          ([key, value]) => key !== 'default' && value
        ) || []
      )
    },
    sizesDetailsEntries() {
      return (
        Object.entries(this.product?.sizes_details)
          ?.reduce((acc, [key, value]) => {
            if (key !== 'dimensions' && value) {
              if (key === 'inside_leg_measurement') {
                value = this.getAmount(value?.amount)
              } else if (key === 'thickness') {
                value = this.getAmountMM(value?.amount)
              } else if (key === 'back_length') {
                value = this.getAmount(value)
              }
              acc.push([key, value])
            }
            return acc
          }, [])
          ?.sort(
            (a, b) =>
              this.sizesDetailsOrder[a[0]] - this.sizesDetailsOrder[b[0]]
          ) || []
      )
    },
    sizesDetailsOrder() {
      return {
        top_cut: 0,
        bottom_cut: 1,
        fit_intention: 2,
        fit_details: 3,
        waist_type: 4,
        leg_shape: 5,
        thickness: 6,
        back_length: 7,
        inside_leg_measurement: 8,
        length_information: 9,
        model_size_data: 10,
      }
    },
  },
  methods: {
    getAmount(amount) {
      if (this.$i18n.locale === 'en-us')
        return `${Math.round(amount / 2.54)} ${this.wording.size_fit_inche}`
      else if (this.$i18n.locale.includes('-ca'))
        return `${Math.round(amount)} ${
          this.wording.size_fit_centimeter
        } | ${Math.round(amount / 2.54)} ${this.wording.size_fit_inche}`
      else return `${Math.round(amount)} ${this.wording.size_fit_centimeter}`
    },
    getAmountMM(amount) {
      if (this.$i18n.locale === 'en-us')
        return `${Math.round(amount / 2.54 / 10)} ${
          this.wording.size_fit_inche
        }`
      else if (this.$i18n.locale.includes('-ca'))
        return `${Math.round(amount)} ${this.wording.size_fit_millimeter} | ${
          Math.round(amount / 2.54) / 10
        } ${this.wording.size_fit_inche}`
      else return `${Math.round(amount)} ${this.wording.size_fit_millimeter}`
    },
  },
}
